import type { FaireProductEntity } from "../../entity_types/product";

export const p_b19626j6f7: FaireProductEntity = {
  token: "p_b19626j6f7",
  type: "product",
  name: "Sea Salt Grapefruit Classic Candle",
  brandToken: "b_345v3zg1",
  brandName: "Apotheke",
  imageUrl:
    "https://cdn.faire.com/fastly/1faa9190248897e5508a8a1abdaf5f51e800a1b08ff469c3b726eea2d7f302fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10b628434bf83c3e1518336558debdcca63a82cf09ffa7517adebbb3fd580fa3.jpeg",
    "https://cdn.faire.com/fastly/d863efe9daa53b38d8c53bb932896c0f0e0f9397afa719e3b16c76d4e1e53b68.jpeg",
  ],
  priceDollars: 23,
  description:
    'The Fragrance\nSea Salt Grapefruit balances tangy sea salt, black pepper, and ripe grapefruit with sweet tarragon and a fresh dewdrop accord for a bright and citrusy fragrance.\n\nThe Product\nMade with a premium soy wax blend and essential and perfume-grade fragrance oils, this luxury scented candle is designed to provide a clean-burning and exceptional scent experience.\n\nThe Vessel\nThe white translucent glass vessel with its velvety-smooth luxe matte finish enhances any space with a modern and timeless design.\n\nThe Details\n\nNet Weight: 10.5 oz. (296 g)\nApproximate Burn Time: 60-70 hours\nCandle Dimensions: 3.5" DIA x 3.9" H\nFragrance Family: Citrus\nTop Notes: Grapefruit, Lemon, Tropical Fruits, Green Fruits, Mint\nMiddle Notes: Green Florals, Watery Nuances, Peach, Red Berry\nBottom Notes: Musk, Coconut, Amber\nMade in the USA\n\nFor more information about our products, visit Ingredients.',
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:48.597Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
